// extracted by mini-css-extract-plugin
module.exports = {"container":"ca","card":"cb","image":"cc","imageContainer":"cd","title":"ce","text":"cf"};